export default "__VITE_ASSET__883995ea__"